/**
 * Button component.
 * 
 * TODO: Conditionalize the icon container.
 */

/** Dependencies -------------------------------------------- */

// External

import { useId } from 'react'
import classNames from 'classnames'

// Internal

import Icon from './icon'

/** Constants ----------------------------------------------- */

const baseClassName = 'button'

/** Components ---------------------------------------------- */

export default function Button( props ) {

    const {
        title,
        link,
        type               = 'solid',
        theme              = 'primary',
        size               = 'default',
        layout             = 'default',
        leadingIconProps,
        trailingIconProps,
        tooltipProps,
        isScreenReaderOnly = false,
        className,
        ...additionalProps
    } = props

    const id = useId()

    const Component = link
        ? ( props ) => <a { ...props }/>
        : ( props ) => <button { ...props }/>

    const consolidatedClassName = classNames(
        baseClassName,
        { [`is-type-${type}`]: type },
        { [`is-theme-${theme}`]: theme },
        { [`is-size-${size}`]: size },
        { [`is-layout-${layout}`]: layout },
        { 'has-icon': leadingIconProps || trailingIconProps },
        { 'is-screen-reader-only': isScreenReaderOnly },
        className
    );

    return (
        <Component id={ id } className={ consolidatedClassName } href={ link } { ...additionalProps }>
            <Icon className={ `${baseClassName}__icon` } { ...leadingIconProps }/>
            <span className={ `${baseClassName}__title` }>
                { title }
            </span>
            <Icon className={ `${baseClassName}__icon` } { ...trailingIconProps }/>
        </Component>
    )
}